import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import backend from 'i18next-xhr-backend';
import detector from 'i18next-browser-languagedetector';

import commonEn from './en/common.json';
import commonEs from './es/common.json';

i18n.use(backend)
    .use(detector)
    .use(initReactI18next)
    .init({
        load: 'languageOnly',
        fallbackLng: {
            'en-US': ['en'],
            'es-MX': ['es'],
        },
        debug: process.env.NODE_ENV === 'development',

        interpolation: {
            escapeValue: false, // React does this automatically
        },

        resources: {
            en: {
                common: commonEn,
            },
            es: {
                common: commonEs,
            },
        },

        defaultNS: 'common',
    });

export default i18n;
